import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_DOMAIN,
  timeout: 30_000,
});

// axiosInstance.interceptors.request.use(
//   function (config) {

//     // console.log(`AXIOS REQ 1: ${JSON.stringify(config)}`);
//     // config.headers.set("Content-Type", "application/json");
//     // console.log(`AXIOS REQ 2: ${JSON.stringify(config)}`);

//     return config;
//   },
//   function (error) {
//     // Обработать ошибку
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
